import React, { Component } from 'react';
import { Icon } from 'antd';
import moment from "moment"
import { Link } from "react-router-dom"
export default class Popularcourses extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  handleClick = (e, slug) => {
    e.preventDefault()
    this.props.history.push(`/courses/${slug}`);
  }
  cuttext(text, maxlength) {
    if (text.length > maxlength) {
      var newtext = text.slice(0, maxlength);
      newtext += "..."
      return newtext
    } else return text
  }

  checkHours = (num) => {
    let hours = Math.floor(num / 3600);
    return hours
  }

  courseTime = (e) => {
    e.preventDefault()
  }

  render() {
    var { courses } = this.props;

    return (
      <div>
        <div className="popular-course">
          <div className="container">
            <div className="theme-title">
              <h6>Featured Course</h6>
              <h2>Populer Course</h2>
              <Link to="/courses" className="tran3s">See All Course</Link>
            </div>

            <div className="row">
              {courses.sort().slice(0, 6).map((course, key) => (
                <div key={key} className="col-md-4 col-xs-6 wow fadeInLeft">
                  <div className="single-course">
                    <div className="image-box">
                      <img src={course.image} alt={course.title} /></div>
                    <div className="text">
                      {/* <div className="image"><img src={course.image} alt={course.title}/></div> */}

                      <h5><a href="#" onClick={(e) => this.handleClick(e, course.slug)} className="tran3s">{course.title}</a></h5>
                      <p>{this.cuttext(course.description, 80)}</p>
                      <div className="name clearfix">
                        {/* <h6 className="float-left">{course.userName}</h6> */}
                      </div>
                      <ul className="clearfix">
                        <li className="float-left">
                          <i className="flaticon-time"></i>
                          <a href="#" className="tran3s" onClick={(e) => this.courseTime(e)}>{this.checkHours(course.duration) ? moment.utc(course.duration * 1000).format('hh:mm:ss') + ' hrs' : moment.utc(course.duration * 1000).format('mm:ss') + ' mins'}</a>
                        </li>
                        <li className="float-right">
                          <div className="name  float-right">
                            {course.isNewCourse ? <span className="p-bg-color float-right">New</span> : null}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="col-md-4 col-xs-6 wow fadeInUp">
                            <div className="single-course">
                                <div className="image-box"><img src="/img/courses/2.jpg" alt=""/></div>
                                <div className="text">
                                    <div className="image"><img src="/img/courses/5.jpg" alt=""/></div>
                                    <div className="name clearfix">
                                        <h6 className="float-left">Abdus Salam</h6>
                                        <strong className="s-color float-right">$79<sup>.99</sup></strong>
                                    </div>
                                    <h5><a href="course-details.html" className="tran3s">Angular 2 Essential Training JavaScript Framework</a></h5>
                                    <p>Lorem ipsum dolor sit amet, duo vide etiam periculis ei, ius in lorem iuvaret. Cum nemro assum copiosae despite...</p>
                                    <ul className="clearfix">
                                        <li className="float-left">
                                            <i className="flaticon-people"></i>
                                            <a href="#" className="tran3s">1 min</a>
                                        </li>
                                
                                    </ul>
                                </div>
                            </div> 
                        </div>  */}
            </div>
          </div>
        </div>

      </div>
    )
  }
}
